module.exports = __webpack_public_path__ + "img/10.b61cfe58.jpeg";